import { LoadState } from "../../constants/enums";
import { IUserBranch } from "./userBranch.types";

export const defaultUserBranch: IUserBranch = {
  branch_uuid: null,
  branch_name: "",
  status: "ACTIVE",
};
